import { Component } from '@angular/core';

@Component({
  selector: 'teiasoft-emptyfield',
  templateUrl: './teiasoft-emptyfield.component.html',
  styleUrls: ['./teiasoft-emptyfield.component.scss']
})
export class TeiasoftEmptyfieldComponent {

}
